import { TSectionPage } from "models";
import { getPageName } from "../../hooks";

// A simplified version of our task for the user to drag around
export const DragPreview = ({ pageElement }: { pageElement: TSectionPage }) => {
  return <div className="page-element drag-preview">{getPageName(pageElement.type)}</div>;
};
